//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'VDialog',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      noMask: {
        type: Boolean,
        default: false,
      },
    },
  };



// WEBPACK FOOTER //
// ./src/components/commons/Dialog/Dialog.vue